import React from "react";

function AuthLayout({ children }) {
  return (
    <div
      className="hold-transition login-page register-page"
      style={{
        "background-image":
          'url("https://i0.wp.com/specure.com/wp-content/uploads/sites/5/2021/08/buyers-hands-raising-auction-bid-paddles-vector-21029356.jpeg")',
        "background-size": "cover",
      }}
    >
      {children}
    </div>
  );
}
export default AuthLayout;
